export default __webpack_public_path__ + "static/media/annex1.734fcc53.png";